import { memo, useState } from "react";
import { Modal, Box, Typography, Button } from "@mui/material";
import {
  blackColor,
  violetColor,
  whiteColor,
  lightVioletColor,
  lightBlackColor,
} from "../constants/colors";
import Dropzone from "react-dropzone";
import CloseCircle from "../assets/icons/close-circle.svg";
import UploadIcon from "../assets/icons/upload.png";
import ZipFileIcon from "../assets/icons/zip-file.png";
import TextInput from "./TextInput";
import { truncateString } from "../helpers/truncateString";
import axios from "axios";

const ModalTemplate = ({
  isModalOpen,
  setIsModalOpen,
}) => {
  const [templateName, setTemplateName] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [templateDescription, setTemplateDescription] = useState("");

  const handleClose = () => {
    setIsModalOpen(false);
  };

  const handleFileChange = (acceptedFiles) => {
    console.log(acceptedFiles);
    const file = acceptedFiles[0];
    if (file && file.type === "application/zip") {
      setSelectedFile(file);
    } else {
      alert("Please select a .zip file.");
    }
  }

  const sendTemplate = async () => {
    if (!selectedFile) {
      alert("Please select a file to upload.");
      return;
    }

    try {
      const formData = new FormData();
      if (!templateName || !templateDescription) {
        alert("Please fill all the fields");
        return;
      }
      formData.append("name", templateName);
      formData.append("description", templateDescription);

      formData.append("zipfile", selectedFile);

      const response = await axios.post(
        "https://webrender-be.homagames.com/api/v1/uploadTemplate",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setSelectedFile(null);

      console.log(response.data);
    } catch (error) {
      console.error(error);
    }
  }

  console.log("selectedFile", selectedFile);

  const getFileSize = (size: number) => {
    if (size >= 1024 * 1024) {
      return `${(size / (1024 * 1024)).toFixed(1)} MB`;
    } else {
      return `${(size / 1024).toFixed()} KB`;
    }
  };

  return (
    <Box>
      <Modal open={isModalOpen} onClose={handleClose}>
        <Box
          sx={{
            outline: "none",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            maxWidth: "700px",
            height: "550px",
            width: "100%",
            borderRadius: "10px",
            padding: "30px",
            backgroundColor: whiteColor,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Roboto",
                  color: "rgba(110,90,180, 1)",
                  fontWeight: "500",
                  fontSize: "36px",
                  lineHeight: "36px",
                }}
              >
                UPLOAD TEMPLATE
              </Typography>
              <img
                onClick={handleClose}
                src={CloseCircle}
                alt="close-circle"
                style={{ width: "35px", height: "35px", cursor: "pointer" }}
              />
            </Box>
            <TextInput
              label={"Template Name:"}
              containerStyle={{
                marginTop: "20px",
              }}
              inputStyle={{
                width: "305px",
              }}
              placeholder={"Enter template name"}
              value={templateName}
              onChange={setTemplateName}
            />
            <TextInput
              containerStyle={{
                marginTop: "20px",
              }}
              label={"Template Description:"}
              inputStyle={{
                width: "305px",
              }}
              placeholder={"Enter template description"}
              value={templateDescription}
              onChange={setTemplateDescription}
            />
            <Box sx={{ marginTop: "20px" }}>
              <Dropzone
                onDragEnter={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                onDrop={handleFileChange}
              >
                {({ getRootProps, getInputProps }) => (
                  <section>
                    <Box
                      {...getRootProps()}
                      sx={{
                        width: "100%",
                        height: "260px",
                        paddingY: "40px",
                        paddingX: "24px",
                        border: `3px dashed ${lightVioletColor}`,
                        backgroundColor: "rgba( 255, 0, 236, 0.04 )",
                        display: "flex",
                        justifyContent: selectedFile
                          ? "space-around"
                          : "center",
                        alignItems: "center",
                        borderRadius: "25px",
                        cursor: "pointer",
                      }}
                    >
                      <input
                        {...getInputProps()}
                        type="file"
                        id="zipfile"
                        name="zipfile"
                        accept="*.zip"
                      />
                      {selectedFile?.name && (
                        <Box
                          sx={{
                            height: "100%",
                            width: "160px",
                            borderRadius: "16px",
                            overflow: "hidden",
                            backgroundColor: "rgba(0, 0, 0, 0.1)",
                            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                          }}
                        >
                          <Box
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              setSelectedFile(null);
                            }}
                            sx={{
                              width: "100%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-end",
                              cursor: "pointer",
                              paddingRight: "10px",
                              paddingTop: "10px",
                              pointerEvents: "all",
                            }}
                          >
                            <img
                              src={CloseCircle}
                              style={{ height: "20px" }}
                              alt={"close"}
                            />
                          </Box>
                          <Box
                            sx={{
                              height: "140px",
                              borderRadius: "16px",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                              overflow: "hidden",
                            }}
                          >
                            <img
                              src={ZipFileIcon}
                              style={{ height: "50px" }}
                              alt="zip"
                            />
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                marginTop: "6px",
                              }}
                            >
                              <Typography
                                sx={{
                                  color: "rgba(0, 0, 0, 0.5)",
                                  fontWeight: 500,
                                  fontSize: "16px",
                                }}
                              >
                                {truncateString(selectedFile.name, 14)}
                              </Typography>
                            </Box>
                            <Box>
                              <Typography
                                sx={{
                                  color: "rgba(0, 0, 0, 0.5)",
                                  fontWeight: 500,
                                  fontSize: "16px",
                                }}
                              >
                                {getFileSize(selectedFile.size)}
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      )}
                      <Box
                        sx={{
                          minWidth: "200px",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <img
                          style={{
                            height: "60px",
                          }}
                          src={UploadIcon}
                          alt="upload"
                        />

                        <Typography
                          sx={{
                            marginTop: "10px",
                            fontSize: "18px",
                            fontWeight: "500",
                            color: lightBlackColor,
                            textAlign: "center",
                          }}
                        >
                          Drag and drop files here
                        </Typography>
                      </Box>
                    </Box>
                  </section>
                )}
              </Dropzone>
            </Box>
          </Box>
          <Box
            sx={{
              marginTop: "auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Button
              onClick={sendTemplate}
              sx={{
                borderColor: blackColor,
                backgroundColor: whiteColor,
                "&:hover": {
                  backgroundColor: whiteColor,
                },
              }}
              variant="contained"
              color="secondary"
            >
              <Typography
                sx={{ color: violetColor, fontWeight: "500", fontSize: "20px" }}
              >
                UPLOAD
              </Typography>
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default memo(ModalTemplate)
